<template>
  <div class="scard-list">
    <article
      class="scard scard--blue"
      :class="{ 'scard--hover': hoverState.erwachsene }"
      @click="startRechner('erwachsene')"
      @mouseover="hoverState.erwachsene = true"
      @mouseleave="hoverState.erwachsene = false"
      role="button"
      tabindex="0"
    >
      <div class="scard__top">
        <div class="scard__icon scard__icon--blue">
          <v-icon
            :icon="hoverState.erwachsene ? 'mdi-tooth' : 'mdi-tooth-outline'"
            color="#0f4c81"
            size="32"
          />
        </div>
        <div class="scard__body">
          <span class="scard__eyebrow">
            <span class="scard__dot scard__dot--blue"></span>ERWACHSENE
          </span>
          <h3 class="scard__title">Zahnzusatzversicherung</h3>
          <p class="scard__sub">Schwerpunkt Zahnersatz &amp; Zahnerhalt</p>
        </div>
      </div>

      <ul class="scard__chips">
        <li><v-icon size="11" color="#0f4c81">mdi-check</v-icon>Zahnersatz</li>
        <li><v-icon size="11" color="#0f4c81">mdi-check</v-icon>Zahnerhalt</li>
        <li><v-icon size="11" color="#0f4c81">mdi-check</v-icon>Implantate</li>
      </ul>

      <div class="scard__foot">
        <v-btn
          variant="flat"
          color="primary"
          rounded="0"
          size="default"
          class="nocaps scard__btn"
          append-icon="mdi-arrow-right-circle"
        >
          Vergleich starten
        </v-btn>
      </div>
    </article>

    <article
      class="scard scard--yellow"
      :class="{ 'scard--hover': hoverState.kinder }"
      @click="startRechner('kind')"
      @mouseover="hoverState.kinder = true"
      @mouseleave="hoverState.kinder = false"
      role="button"
      tabindex="0"
    >
      <div class="scard__top">
        <div class="scard__icon scard__icon--yellow">
          <v-icon
            :icon="hoverState.kinder ? 'mdi-tooth' : 'mdi-tooth-outline'"
            color="#f6a800"
            size="32"
          />
        </div>
        <div class="scard__body">
          <span class="scard__eyebrow">
            <span class="scard__dot scard__dot--yellow"></span>KINDER
          </span>
          <h3 class="scard__title">Zahnzusatzversicherung</h3>
          <p class="scard__sub">
            Schwerpunkt Kieferorthopädie &amp; Kinderleistungen
          </p>
        </div>
      </div>

      <ul class="scard__chips scard__chips--yellow">
        <li><v-icon size="11" color="#b27a00">mdi-check</v-icon>Kieferorthopädie</li>
        <li><v-icon size="11" color="#b27a00">mdi-check</v-icon>Prophylaxe</li>
        <li><v-icon size="11" color="#b27a00">mdi-check</v-icon>Kinderbonus</li>
      </ul>

      <div class="scard__foot">
        <v-btn
          variant="flat"
          color="primary"
          rounded="0"
          size="default"
          class="nocaps scard__btn"
          append-icon="mdi-arrow-right-circle"
        >
          Vergleich starten
        </v-btn>
      </div>
    </article>

    <article
      class="scard scard--purple"
      :class="{ 'scard--hover': hoverState.plus60 }"
      @click="startRechner('60plus')"
      @mouseover="hoverState.plus60 = true"
      @mouseleave="hoverState.plus60 = false"
      role="button"
      tabindex="0"
    >
      <div class="scard__top">
        <div class="scard__icon scard__icon--purple">
          <v-icon
            :icon="hoverState.plus60 ? 'mdi-tooth' : 'mdi-tooth-outline'"
            color="#513b83"
            size="32"
          />
        </div>
        <div class="scard__body">
          <span class="scard__eyebrow">
            <span class="scard__dot scard__dot--purple"></span>60 PLUS
          </span>
          <h3 class="scard__title">Zahnzusatzversicherung 60+</h3>
          <p class="scard__sub">Schwerpunkt Zahnerhalt &amp; Prothetik</p>
        </div>
      </div>

      <ul class="scard__chips scard__chips--purple">
        <li><v-icon size="11" color="#513b83">mdi-check</v-icon>Zahnerhalt</li>
        <li><v-icon size="11" color="#513b83">mdi-check</v-icon>Prothetik</li>
        <li><v-icon size="11" color="#513b83">mdi-check</v-icon>Implantate</li>
      </ul>

      <div class="scard__foot">
        <v-btn
          variant="flat"
          color="primary"
          rounded="0"
          size="default"
          class="nocaps scard__btn"
          append-icon="mdi-arrow-right-circle"
        >
          Vergleich starten
        </v-btn>
      </div>
    </article>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const hoverState = reactive({
  erwachsene: true,
  kinder: false,
  plus60: false,
});

function startRechner(segment) {
  switch (segment) {
    case "erwachsene":
      router.push("/vergleich/starten");
      break;
    case "kind":
      router.push("/vergleich/starten/kind");
      break;
    case "60plus":
      router.push("/vergleich/starten/60plus");
      break;
    default:
      console.error("Unbekanntes Segment:", segment);
  }
}
</script>

<style scoped>
.scard-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.scard {
  position: relative;
  background: #ffffff;
  border: 1px solid #d8dde5;
  border-left: 3px solid #d8dde5;
  border-radius: 3px;
  padding: 14px 16px 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
  display: grid;
  grid-template-rows: auto auto auto;
  gap: 12px;
}
.scard:hover,
.scard--hover {
  background: #fbfcfe;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04),
    0 6px 20px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.scard--blue {
  border-left-color: #0f4c81;
}
.scard--blue:hover,
.scard--blue.scard--hover {
  background: #f7faff;
  border-color: #c8d8e8;
  border-left-color: #0f4c81;
}
.scard--yellow {
  border-left-color: #f6a800;
}
.scard--yellow:hover,
.scard--yellow.scard--hover {
  background: #fffbe6;
  border-color: #f3dba0;
  border-left-color: #f6a800;
}
.scard--purple {
  border-left-color: #513b83;
}
.scard--purple:hover,
.scard--purple.scard--hover {
  background: #f7f4fb;
  border-color: #d4cae5;
  border-left-color: #513b83;
}

.scard__top {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  gap: 14px;
  align-items: center;
}
.scard__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: #fafbfc;
  border: 1px solid #eef1f6;
  border-radius: 3px;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.scard:hover .scard__icon--blue,
.scard--hover .scard__icon--blue {
  background: #eaf2fa;
  border-color: #c8d8e8;
}
.scard:hover .scard__icon--yellow,
.scard--hover .scard__icon--yellow {
  background: #fff5cc;
  border-color: #f3dba0;
}
.scard:hover .scard__icon--purple,
.scard--hover .scard__icon--purple {
  background: #ede8f5;
  border-color: #d4cae5;
}

.scard__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.scard__eyebrow {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #5b6473;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
.scard__dot {
  width: 6px;
  height: 6px;
  display: inline-block;
  margin-right: 8px;
}
.scard__dot--blue {
  background: #0f4c81;
}
.scard__dot--yellow {
  background: #f6a800;
}
.scard__dot--purple {
  background: #513b83;
}
.scard__title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
}
.scard__sub {
  font-size: 12.5px;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
}

.scard__chips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.scard__chips li {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #0f4c81;
  background: #f0f5fa;
  border: 1px solid #d8e3ee;
  border-radius: 999px;
  padding: 3px 10px 3px 8px;
}
.scard__chips--yellow li {
  color: #b27a00;
  background: #fff8e0;
  border-color: #f3dba0;
}
.scard__chips--purple li {
  color: #513b83;
  background: #f3eef9;
  border-color: #d4cae5;
}

.scard__foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px dashed #eef1f6;
  padding-top: 10px;
}
.scard__btn {
  letter-spacing: 0.2px;
  font-weight: 700;
}

@media (max-width: 780px) {
  .scard {
    padding: 12px 12px 10px;
    gap: 10px;
  }
  .scard__top {
    grid-template-columns: 48px minmax(0, 1fr);
    gap: 10px;
  }
  .scard__icon {
    width: 48px;
    height: 48px;
  }
  .scard__title {
    font-size: 15px;
  }
  .scard__sub {
    font-size: 12px;
  }
  .scard__chips li {
    font-size: 11px;
    padding: 2px 8px 2px 6px;
  }
  .scard__foot {
    justify-content: stretch;
  }
  .scard__btn {
    flex: 1 1 auto;
    width: 100%;
  }
}
</style>
